import {
  Briefcase, Car, Dog, FirstAidKit, Footprints, Heartbeat, HouseLine, Motorcycle, Package, Question, Taxi, Truck,
} from "@phosphor-icons/react";

const ICONS = {
  auto: Car, truck: Truck, motorcycle: Motorcycle, rideshare: Taxi, slip_fall: Footprints,
  medical_malpractice: FirstAidKit, product_liability: Package, nursing_home: HouseLine,
  wrongful_death: Heartbeat, dog_bite: Dog, workers_comp: Briefcase,
};

export const caseTypeIcon = (value) => ICONS[value] || Question;
